'use client';
import Cookies from 'js-cookie';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export const REDIRECT_AFTER_LOGIN_KEY = 'redirectAfterLogin';

export function SetRedirectCookieEffect() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const redirect = searchParams?.get('redirect');

    if (typeof redirect === 'string') {
      Cookies.set('redirect', redirect);
      localStorage.setItem(REDIRECT_AFTER_LOGIN_KEY, redirect);
    }
  }, [searchParams]);

  return null;
}
